






















import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { PRODUCTS_ADDITIONAL_API } from '~/assets/config/api-path'
import {
  ILabel,
  IProduct,
  IProductsOnImageItem,
} from '~/assets/interfaces/products'

@Component({
  components: {
    ComponentProductAdditional: () =>
      import('~/components/products/product-additional.vue'),
  },
})
export default class ComponentPageIndexProducts extends mixins(MixinGeneral) {
  @Prop({ type: Number, default: 0 }) private blockId!: number
  @Prop({ type: String, default: '' }) private entity!: string
  @Prop({ type: Number, default: 0 }) private entityId: number | string
  @Prop({ type: String, default: '' }) private position: string
  @Prop({ type: Number, default: 5 }) private columnCount!: number

  private items: IProduct[] | IProductsOnImageItem[] = []
  private title = ''
  private url = ''
  private type = 'table'
  private pages = 1
  private perPage = 1
  private currentPage = 1
  private desktopBgImage = ''
  private mobileBgImage = ''
  private labels: ILabel[] = []

  private loading = false

  mounted() {
    this.getData()
  }

  private async getData(concat: boolean = false) {
    if (!this.loading) {
      this.loading = true

      const params = {
        page: this.currentPage,
        entity: this.entity,
        ...(this.entityId && { entityId: this.entityId }),
        ...(this.position && { position: this.position }),
      }

      const response = await this.$axios.$get(
        `${PRODUCTS_ADDITIONAL_API}/${this.blockId}/`,
        { params }
      )
      this.title = response.title || ''
      this.url = response.url || ''
      this.type = response.type || 'table'
      this.pages = response.pages
      this.perPage = response.perPage
      this.desktopBgImage = response.desktopBgImage
      this.mobileBgImage = response.mobileBgImage
      if (response.labels) {
        this.labels = response.labels
      }
      if (concat) {
        this.items = (this.items as []).concat(response.items)
      } else {
        this.items = response.items
      }
      this.loading = false
      this.currentPage++
    }
  }
}
